'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

var _paths2 = require('../events/paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id, person_id) {
  var ignoreCache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return function (dispatch, getState) {
    var commentsForPerson = (0, _paths2.getEventComment)(getState(), event_id, adj_id, person_id);

    if (!ignoreCache && commentsForPerson.size > 0) {
      return;
    }

    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id,
      person_id: person_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.commentsPrefixUrl)(feis_id, event_id, adj_id, person_id)
      },
      types: ['GET_COMMENTS_START', 'GET_COMMENTS', 'GET_COMMENTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/comments/getComments.js
// module id = 621
// module chunks = 0